import subjectManagerPopupComponent from './subjectManagerPopup.component';

const subjectManagerPopupModule = angular.module('app.components.subjectManagerPopup', [])
	.component('subjectManagerPopup', subjectManagerPopupComponent)
	.name;

export default subjectManagerPopupModule;
